import { useLoaderData, useParams } from "react-router";
import ArticleEditor, { ArticleData } from "../components/ArticleEditor";
import { useInfo } from "../context/useInfo";
import { useEffect, useState } from "react";
import NotFound from "./NotFound";
import Login from "./Login";
import NoPermissions from "./NoPermissions";
import LoadingPage from "../components/LoadingPage";


function Edit() {
    const { info, fetchWeb } = useInfo();

    if (info == null) return <Login />
    if (info.badges.find((badge: any) => badge == 4) == null) return <NoPermissions />

    const { article: currentArticle, tags } = useLoaderData();
    if (currentArticle == null || currentArticle["errorCode"] == 404) return <NotFound />

    async function postArticle(article: ArticleData, publish: boolean = false) {
        const response = await fetchWeb('/wiki/articles', {
            method: "PATCH",
            data: {
                id: currentArticle["article_id"],
                url: article.path == currentArticle["article_path"] ? undefined : article.path,
                title: article.title == currentArticle.title ? undefined : article.title,
                content: article.content == currentArticle.content ? undefined : article.content,
                tags: article.tags.map(tag => tag.id),
                publish
            }
        })
        return response
    }

    return <ArticleEditor
        title="Edit wiki article"
        onSubmit={postArticle}
        availableTags={tags}
        baseArticle={{
            path: currentArticle["article_path"],
            ...currentArticle
        }}
        cancelURL={`/${currentArticle["article_path"]}`}
    />
}

export default Edit